import type { ReactNode } from "react";

import { useLocation } from "@remix-run/react";

import { Button, Field, Label, SubmitButton } from "~/components";
import { FieldError, Form, Input, useForm, z } from "~/components/form";

const addLeadSchema = z.object({
    email: z.string({ required_error: "Email is required" }).email().min(1),
    name: z.string({ required_error: "Name is required" }).min(1),
    phone: z.string().optional(),
    notes: z.string().optional(),
    context: z.string().optional(),
    nextUrl: z.string().optional(),
});

export function ContactUsForm({ context }: { context?: string }): ReactNode {
    const location = useLocation();
    const [form] = useForm(addLeadSchema, {
        shouldValidate: "onSubmit",
    });

    return (
        <Form method="post" action="/modal" className="flex flex-col gap-4" form={form}>
            <input type="hidden" name="nextUrl" value={location.pathname} />
            <input type="hidden" name="context" value={context} />
            <section className="flex flex-col gap-6">
                <Field>
                    <Label htmlFor="name">Name</Label>
                    <Input name="name" type="text" placeholder="Enter your name" />
                    <FieldError name="name" />
                </Field>
                <Field>
                    <Label htmlFor="email">Email</Label>
                    <Input name="email" type="text" placeholder="Enter your email" />
                    <FieldError name="email" />
                </Field>
                <Field>
                    <Label htmlFor="phone">Phone (optional)</Label>
                    <Input name="phone" type="text" placeholder="Enter your phone number" />
                    <FieldError name="phone" />
                </Field>
                {context ? (
                    <Field>
                        <Label htmlFor="notes">Notes: </Label>
                        <Input name="notes" type="text" placeholder="Enter relevant notes" />
                        <FieldError name="notes" />
                    </Field>
                ) : null}
            </section>
            <SubmitButton className="self-end w-min" name="intent" value="add-lead">
                Send
            </SubmitButton>
        </Form>
    );
}
